import { render, staticRenderFns } from "./RemissionEdit.vue?vue&type=template&id=47f0157f"
import script from "./RemissionEdit.vue?vue&type=script&lang=js"
export * from "./RemissionEdit.vue?vue&type=script&lang=js"
import style0 from "./RemissionEdit.vue?vue&type=style&index=0&id=47f0157f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports